import { ResourceGroup } from "../GeneratedGraphQL";

export const testResourceGroup1: ResourceGroup = {
  _id: "aaaaaaaaaaaaaaaaaaaaaaaf",
  name: "Test Group 1",
};
export const testResourceGroup2: ResourceGroup = {
  _id: "aaaaaaaaaaaaaaaaaaaaaaff",
  name: "Test Group 2",
};
export const testResourceGroup3: ResourceGroup = {
  _id: "aaaaaaaaaaaaaaaaaaaaafff",
  name: "Test Group 3",
};

export const defaultResourceGroup = testResourceGroup1;
